import { z } from "zod";
import { RoleSchema } from "./roles.js";

export const PortalUserSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  websiteId: z.string().nullable(),
  discordId: z.string().nullable(),
  discordUsername: z.string().nullable(),
  role: RoleSchema,
  internalAffairsAccess: z.boolean(),
  rrCommitteeBadge: z.boolean(),
  badges: z.array(z.enum(["internal_affairs", "system_administrator", "rr_committee"])),
  lastPortalLoginAt: z.string().nullable(),
});
export const PortalUsersPageSchema = z.object({
  items: z.array(PortalUserSchema),
  total: z.number().int(),
  limit: z.number().int(),
  offset: z.number().int(),
});
export type PortalUser = z.infer<typeof PortalUserSchema>;
export type PortalUsersPage = z.infer<typeof PortalUsersPageSchema>;
